<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf = "usuario && usuario.sucesso" class="container-fluid" [ngClass]="usuario.retorno.aparencia">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span id="lblSubMenu">Cadastro de Sub-Frotas - <b>Consulta</b></span>
            </li>
        </ul>
        <div class="clearfix" *ngIf="!isDelete">
            <div class="pull-right subfrotas-botoes">
                <button class="btn btn-default btn-primary " onclick="window.print()"><i class="fa fa-print "></i>
                    Imprimir
                </button>
                <a routerLink="../" class="btn btn-primary"><i class="fa fa-arrow-left"></i> Voltar</a>
            </div>
        </div>
        <div class="panel panel-info">
            <div class="panel-heading">
                <h3 class="panel-title">Dados da Sub-Frota</h3>
            </div>
            <div class="panel-body" *ngIf="subFrota">
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Código da Frota</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.codigoFrota?.toString()?.padStart(6,'0') }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Fantasia da Frota</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.nomeReduzidoFrota }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Código da Sub-Frota</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.codigo?.toString()?.padStart(6,'0') }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Descrição / Fantasia da Sub-Frota</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.descricao }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Sub-Frota Padrão</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.flagPadrao === "S" ? 'SIM' : 'NÃO' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Endereço de Faturamento</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.enderecos[0].estado + ' - ' +
                            subFrota.enderecos[0].cidade + ' - ' +
                            subFrota.enderecos[0].endereco + ' - ' +
                            subFrota.enderecos[0].numero + ' - ' +
                            subFrota.enderecos[0].complemento + ' - ' +
                            subFrota.enderecos[0].cep
                            }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Endereço de Envio de NF</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.enderecos[1].estado + ' - ' +
                            subFrota.enderecos[1].cidade + ' - ' +
                            subFrota.enderecos[1].endereco + ' - ' +
                            subFrota.enderecos[1].numero + ' - ' +
                            subFrota.enderecos[1].complemento + ' - ' +
                            subFrota.enderecos[1].cep
                            }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Centro de Custo</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.flagCentroCusto === "S" ? 'SIM' : 'NÃO' }}</span>
                    </div>
                </div>
                <div *ngIf="subFrota.flagCentroCusto === 'N'" class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Sub-Frota Centro de Custo</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.subFrotaCentroCusto?.toString()?.padStart(6,'0') + ' - ' +
                            subFrota.nomeSubFrotaCentroCusto }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Nota Fiscal aos Cuidados de</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.nomeContato }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Telefone</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.telefoneContato }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 form-group">
                        <span><b>Email NF-e</b></span>
                    </div>
                    <div class="col-md-6 form-group">
                        <span>{{ subFrota.emailNfe }}</span>
                    </div>
                </div>
            </div>
            <span *ngIf="isDelete">* Ao excluir uma Sub-Frota de Faturamento, todas as Sub-Frotas vinculadas a ela serão
                transferidas para a
                Sub-Frota de Faturamento Padrão</span>
        </div>
        <div class="clearfix" *ngIf="isDelete">
            <div class="pull-right subfrotas-botoes">
                <button class="btn btn-default btn-primary " (click)="excluir()"><i class="fa fa-trash "></i> Excluir
                </button>
                <a routerLink="../" class="btn btn-primary"><i class="fa fa-arrow-left"></i> Voltar</a>
            </div>
        </div>
        <div class="panel panel-info" *ngIf="!isDelete">
            <div class="panel-heading">
                <h3 class="panel-title">Veículos Associados</h3>
            </div>
            <div class="lista-container">
                <div>
                    <mat-form-field class="pesquisa-filtro">
                        <input matInput #txtVal (keyup)="applyFilter(txtVal.value)"
                            placeholder="Digite para pesquisar o Veículo ...">
                    </mat-form-field>
                </div>
                <div class="clearfix">
                    <div class="pull-right subfrotas-botoes">
                        <button class="btn btn-primary btn-primary-negativo"
                            (click)="exporter.exportTable('xlsx', {fileName:getXLSName(), sheet: 'Veículos Sub-Frota', Props: {Author: 'CTF'}})"
                            title="Realiza a exportação da consulta no formato Excel."><i
                                class="fa fa-file-excel-o"></i>Excel</button>
                    </div>
                </div>
                <mat-table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">

                    <!-- Placa Column -->
                    <ng-container matColumnDef="placa">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>PLACA</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.placa}} </mat-cell>
                    </ng-container>

                    <!-- Nº de Frota Column -->
                    <ng-container matColumnDef="apelido">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Nº&nbsp;DE&nbsp;FROTA</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.apelido}} </mat-cell>
                    </ng-container>

                    <!-- Ano de Fabrucação Column -->
                    <ng-container matColumnDef="anoFabricacao">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>ANO&nbsp;DE&nbsp;FABRICAÇÃO</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.anoFabricacao}} </mat-cell>
                    </ng-container>

                    <!-- Marca Column -->
                    <ng-container matColumnDef="marca">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>MARCA</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.marca}} </mat-cell>
                    </ng-container>

                    <!-- Modelo Column -->
                    <ng-container matColumnDef="modelo">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>MODELO</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.modelo}} </mat-cell>
                    </ng-container>

                    <!-- Combustível Column -->
                    <ng-container matColumnDef="combustivel">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>COMBUSTÍVEL</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.combustivel}} </mat-cell>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.status}} </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;">
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator class="filter-paginator"
                    [pageSizeOptions]="[10, 20, 50, 100, 500, 1000, 9999]" [pageSize]="10"
                    aria-label="Seleciona a página">
                </mat-paginator>


            </div>
        </div>
    </div>